"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../helpers");
class FormsManager {
    started({ name }) {
        window.dataLayer.push({
            event: 'trackFormular',
            formularhandling: 'formular startet',
            formularnavn: (0, helpers_1.toLowerOrEmpty)(name),
        });
    }
    completed({ name }) {
        window.dataLayer.push({
            event: 'trackFormular',
            formularhandling: 'formular gennemført',
            formularnavn: (0, helpers_1.toLowerOrEmpty)(name),
        });
    }
}
exports.default = FormsManager;
